/**
 * Constants to be used for validation of values in Grid cells
 */ (function(TaskValidationConstants) {
    TaskValidationConstants.TitleMaxLength = 255;
    TaskValidationConstants.MinDateValue = "1984-01-01";
    TaskValidationConstants.MaxDateValue = "2149-12-31";
})(TaskValidationConstants || (TaskValidationConstants = {}));
export var TaskValidationConstants;
